import React, { useState } from 'react';
import { Row, Col, Button } from 'reactstrap';
import FormInput from '../Components/ReactHookFormCustom/FormInput';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import { checkIfApplicantExists, addApplicantToTenant } from '../Services/applicantService';
import { useHistory } from 'react-router-dom';
import { emailFormat } from '../Components/ReactHookFormCustom/FormHelpers';
import { SpinnerLoader } from '../Components/shared/spinnerLoader';

const ApplicantExistsCheck = ({ setEmail, setApplicantAlreadyExistsChecked }) => {
  const { handleSubmit, reset, control } = useForm({});
  const { t } = useTranslation();
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmitWithValidations = (values) => {
    setIsLoading(true);

    checkIfApplicantExists(values.checkIfEmailExists)
      .then((response) => {
        const applicantId = response.data.id;
        const applicantExistsOnTenant = response.data.applicantExistsOnTenant;

        if (applicantId !== 0) {
          handleAlreadyExistingApplicant(values, applicantExistsOnTenant, applicantId);
        } else {
          createNewApplicant(values);
        }
      })
      .catch((error) => {
        //console.log('Error:', error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const createNewApplicant = (values) => {
    Swal.fire({
      html: `<h3>${values.checkIfEmailExists}</h3> ${t('applicants.DOES_NOT_EXISTS')}`,
      showCancelButton: true,
      cancelButtonText: t('common.CANCEL'),
      confirmButtonText: t('applicants.CREATE_NEW'),
      icon: 'question',
    }).then((result) => {
      if (result.isConfirmed) {
        // OK button was clicked
        setApplicantAlreadyExistsChecked(true);
        setEmail(values.checkIfEmailExists);
      }
    });
  };

  const handleAlreadyExistingApplicant = (values, applicantExistsOnTenant, applicantId) => {
    Swal.fire({
      html: `<h3>${values.checkIfEmailExists}</h3> ${t('applicants.ALREADY_EXISTS')}`,
      showCancelButton: true,
      cancelButtonText: t('common.CANCEL'),
      confirmButtonText: t('common.EDIT'),
      icon: 'success',
    }).then((result) => {
      if (result.isConfirmed) {
        if (applicantExistsOnTenant) {
          history.push(`/applications/details?applicantId=${applicantId}&tab=applicationDetails`);
        } else {
          setIsLoading(true);
          addApplicantToTenant(applicantId)
            .then((response) => {
              history.push(`/applications/details?applicantId=${applicantId}&tab=applicationDetails`);
            })
            .catch((error) => {
              //console.log('Error:', error);
            })
            .finally(() => {
              setIsLoading(false);
            });
        }
      }
    });
  };

  const onError = (errorList) => {
    // Handle errors
    //console.log('Errors:', errorList);
  };

  return (
    <form onSubmit={handleSubmit(handleSubmitWithValidations, onError)}>
      <div className="card-body">
        <Row className="align-items-center p-3">
          <Col xs="12" md="10" lg="8">
            <FormInput
              control={control}
              name="checkIfEmailExists"
              id="checkIfEmailExistsId"
              label={t('common.E_MAIL')}
              rules={{
                required: t('common.REQUIRED'),
                pattern: {
                  value: emailFormat,
                  message: t('settings.EMAIL_HELP'),
                },
              }}
            />
          </Col>
        </Row>
      </div>
      <div className="card-footer">
        <Row>
          <Col>
            {isLoading ? (
              <SpinnerLoader />
            ) : (
              <Button color="primary" className="mt-1">
                {t('applicants.CHECK_EMAIL')}
              </Button>
            )}
          </Col>
        </Row>
      </div>
    </form>
  );
};

export default ApplicantExistsCheck;
